// Shared sort for the simple option lists that power the admin settings screens
// and the public inquiry forms. They are ordered by the admin managed order
// field, then alphabetically. Redux keeps these lists in first-seen order, so
// the display order has to be derived here rather than trusted from the API.
export const sortOptions = (options) => {
    return options.slice().sort((a, b) => {
        if (a.order !== b.order) {
            return a.order - b.order
        }
        if (a.name > b.name) {
            return 1
        }
        return -1
    })
}

export default sortOptions
